import React, { Component } from "react";
// Components
import TextField from "./TextField";

// Images import
import PlusIcon from "../assets/images/plus_icon.svg";
import Loader from "./loader";
import moment from "moment-timezone";

//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import AWS from "aws-sdk";
import UploadForm from "./UploadForm";
import ErrorPopUp from "./errorPopUp";
// import ErrorPopUp from "./errorPopUp";
import PopUpCustomAll from "./fpg/create/popUpCustomAll";
import commonImage from "../commonImage";
import DeletefileIcon from "../icons/DeletefileIcon";
import { ADVERTISEMENT_TYPE } from "../cosntants";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

let sub;
class AdvertiesSponsor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getCartFooterDetails: [],
      getCartFooterDocs: [
        {
          _id: Math.random(),
          tileCTA: "",
          advertisementImage: "",
          advertisementTitle: "",
          advertisementURL: "",
          hideFromLive:false
        }
      ],
      imagePreloader: false,
      loaderFlag: false,
      getid: "",
      fname: "",
      lname: "",
      updatedAt: moment.utc().subtract(360, "minutes"),
      isAdvertiesSponsorEdited: false,
    };
    this.validator = new SimpleReactValidator({autoForceUpdate: this,
      validators: {
        urlValidation: {// name the rule
          message: "Please use a valid name of the :attribute",
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val,/^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
          },
          required: false // optional
        }
      }
    });
    this.apiserve = new service();
  }

  getCurrentFormData = () => {
    return cloneDeep({
      getCartFooterDocs: this.state.getCartFooterDocs.map(item => ({
        advertisementImage: item.advertisementImage,
        advertisementTitle: item.advertisementTitle,
        advertisementURL: item.advertisementURL,
        hideFromLive: item.hideFromLive,
      }))
    });
  }

  markAdvertiesSponsorEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isAdvertiesSponsorEdited !== isDirty) {
        this.setState({ isAdvertiesSponsorEdited: isDirty });
      }
    }
  };

  updateState = (newState, callback) => {
    this.setState(newState, () => {
      this.markAdvertiesSponsorEdited();
      if (callback) callback();
    });
  };

  componentDidMount = async () => {
    this.getCartFooter();
    this.getCartFooterEvent();
    this.setState({
      loaderFlag: true
    });
  };

  getCartFooterEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "admin|sponsors|getAdvertisements":
          if (!response.error) {
            var getCartFooterDocs =
              response &&
              response.data &&
              response.data.data[0] &&
              response.data.data[0].advertisements.map((item, i) => {
                var List = {
                  _id: Math.random(),
                  advertisementImage: item.advertisementImage,
                  advertisementTitle: item.advertisementTitle,
                  advertisementURL: item.advertisementURL,
                  hideFromLive: item.hideFromLive,
                };
                return List;
              });
            if (getCartFooterDocs) {
              this.setState({
                getCartFooterDetails: response.data,
                getCartFooterDocs:
                  getCartFooterDocs !== undefined ? getCartFooterDocs : this.state.getCartFooterDocs,
                error: response.data.error,
                loaderFlag: false,
              }, () => {
                this.setState({ initialData: this.getCurrentFormData(), isAdvertiesSponsorEdited: false });
              });
            } else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });

          break;
        case "admin|sponsors|updateAdvertisement":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.setState({ isAdvertiesSponsorEdited: false });
              this.apiserve.success("CartFooter updated successful.");
            });
            this.getCartFooter();
          }
          break;
      }
    });
  };

  getCartFooter = () => {
    this.apiserve.sendevent("admin|sponsors|getAdvertisements", {});
  };
  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };

  handleChange = (e, id) => {
    const { name, value } = e.target;
    const getCartFooterDocs = Object.assign([], this.state.getCartFooterDocs).map(m => {
      if (m._id === id) m[name] = value;
      return m;
    });
    this.updateState({ getCartFooterDocs });
  };

  handleCheck = (e, id) => {
    const { name, checked } = e.target;
    const getCartFooterDocs = Object.assign([], this.state.getCartFooterDocs).map(m => {
      if (m._id === id) m[name] = checked;
      return m;
    });
    this.updateState({ getCartFooterDocs });
  };

  onChangeFile(e, id) {
    // e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState(
        {
          file: file
          // base64: file,
        },
        () => {
          const fileList = Math.round(file && file.size / 1024);
          if (fileList >= 2048) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file smaller than 2 MB"
            });
            return false;
          }
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            if (file) {
              const image = new Image();
              image.src = event.target.result;
              image.onload = () => {
                if (image.width !== 300 || image.height !== 600) {
                  this.setState({
                    errorMsg: true,
                    errorMsgShow: "Please upload an image with dimensions 300x600"
                  });
                  return false;
                } else {
                  setTimeout(() => {
                    this.imageUpload(file, id,event.target.result);
                  }, 0);
                }
              };
            }
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file for PNG,JPG or JPEG"
            });
          }
        }
      );
    };
  }

  submitFn = async e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const { getCartFooterDocs } = this.state;
      let data = getCartFooterDocs.map(item => {
        var dataList = {
          id: item._id,
          tile: item.tile
        };
        return dataList;
      });
      getCartFooterDocs.map(item => {
        delete item._id;
      });
      let updateCart = {
        "advertisementType": ADVERTISEMENT_TYPE.ORDER_CONFIRMATION,
        "advertisements": getCartFooterDocs
      };
      this.apiserve.sendevent("admin|sponsors|updateAdvertisement", updateCart);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  imageUpload = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet= commonImage(file, false,'',img)
    fileSet.then((value) => {
      this.state.getCartFooterDocs.forEach(sponsorList => {
        if (sponsorList._id === id) {
          const imagePreloaderId = `imagePreloader_${id}`;
          const newState = { ...this.state };
          newState[imagePreloaderId] = false;
          newState.isAdvertiesSponsorEdited = true;
          this.setState(newState);
          sponsorList.advertisementImage = value || "";
        }
      });
      this.setState({});
    });
  };

  cancelBTN = e => {
    e.preventDefault();
    window.location.reload();
  };

  onDeleteImagePopup = e => {
    const getCartFooterDocs = Object.assign([], this.state.getCartFooterDocs).map(image => {
      if (image._id === this.state.deleteId) image.advertisementImage = "";
      return image;
    });
    this.updateState({ getCartFooterDocs, deleteImagePopup: false });
  };
  deleteImage = id => this.setState({ deleteImagePopup: true, deleteId: id });
  closeAdminUser = () => this.setState({ deleteImagePopup: false, deleteId: "" });

  render() {
    return (
      <>
        <div className="ticketing_content fpg_tabcontent sponsor_content">
          {this.state.getCartFooterDocs.map((item, i) => {
            const imagePreloaderState = `imagePreloader_${item._id}`;
            return (
              <div className="home_page_title_wpr ">
                <div className="title_header">
                  <p>Order Confirmation Page Ad Placement</p>
                </div>
                <div className="title_content">
                  <>
                    <div className="title_content_img">
                      <div className="title_content_img_box loader-main">
                        {this.state[imagePreloaderState] ? (
                          <Loader />
                        ) : (
                          <img
                            src={
                              item.advertisementImage
                                ? this.apiserve.imageUrl + item.advertisementImage
                                : item.advertisementURL
                                ? item.advertisementURL
                                : "/images/image-placeholder.png"
                            }
                            onError={e => {
                              e.target.src = "/images/image-placeholder.png";
                            }}
                          />
                        )}
                        <UploadForm
                          item={item}
                          handleImage={e => this.onChangeFile(e, item._id)}
                        />
                        {console.log(item,"item")}
                        {item.advertisementImage !== '' && <span className="remove_file pointer" onClick={() => this.deleteImage(item._id)}><DeletefileIcon /></span>}
                        <span className="error_msg">{this.props.imageErr}</span>
                      </div>
                      <span className="error_note">Max size 2MB</span>
                      <span className="error_note">300 x 600</span>
                    </div>
                    <div className="title_content_form">
                      <div className="form_group form_group_input">
                        <div className="field_row_inner">
                          <label>Title</label>
                          <div className="field_input relative">
                            <textarea
                              name="advertisementTitle"
                              value={item.advertisementTitle}
                              id={item._id}
                              label="Tile Title"
                              type="text"
                              onChange={e => this.handleChange(e, item._id)}
                            ></textarea>
                          <span style={{ color: "red" }}>
                            {this.validator.message("Tile Title " + i, item.advertisementTitle, "required")}
                          </span>
                          </div>
                        </div>
                      </div>
                      <>
                        <div className="form_group form_group_input">
                          <TextField
                            name="advertisementURL"
                            id={item._id}
                            label="URL"
                            type="text"
                            value={item.advertisementURL}
                            onChange={e => this.handleChange(e, item._id)}
                            fpgerror={this.validator.message("tile URL " + i, item.advertisementURL, "required|urlValidation")}
                          />
                        </div>
                      </>
                      <div className="form_group form_group_input">
                        <div className="field_row_inner">
                          <label>Hide From Live</label>
                          <div className="relative mt_10">
                              <div className="checkbox_field_row">
                                  <div className="checkBox">
                                      <input
                                          type="checkbox"
                                          id={`hideFromLive_`+i}
                                          name={`hideFromLive`}
                                          checked={item.hideFromLive}
                                          onChange={(e) => this.handleCheck(e, item._id)} />
                                      <label for={`hideFromLive_`+i} style={{ width: "auto" }}></label>
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            );
          })}
          <div className="text_center field_row w_100 buttons_outer">
            <button className="uppercase" onClick={this.cancelBTN}>
              CANCEL
            </button>
            <button disabled={this.state.loaderFlag || (this.state.getCartFooterDetails && this.state.getCartFooterDetails.data && this.state.getCartFooterDetails.data.length > 0 ? !this.state.isAdvertiesSponsorEdited : false)} className={`${this.state.loaderFlag || (this.state.getCartFooterDetails && this.state.getCartFooterDetails.data && this.state.getCartFooterDetails.data.length > 0 ? !this.state.isAdvertiesSponsorEdited : false) ? '' : "active"}`} type="button" onClick={e => this.submitFn(e)}>
              SAVE
            </button>
          </div>
          {this.state.errorMsg && (
            <ErrorPopUp errorMsg={this.state.errorMsgShow} errorMsgPopup={this.validateModel} />
          )}
          {this.state.deleteImagePopup ? (
            <PopUpCustomAll
              HeaderName="Delete Image?"
              insideDetails="Are You Sure ?"
              insideData="You want to delete this image"
              popupState={() => this.closeAdminUser()}
              yesPopUp={() => this.onDeleteImagePopup()}
            />
          ) : (
            ""
          )}
          {this.state.loaderFlag && <Loader />}
        </div>
      </>
    );
  }
}
export default AdvertiesSponsor;
